/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Logo_AltInputs */

const en_ateliere_logo_alt = /** @type {(inputs: Ateliere_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ateliere logo`)
};

const fr_ateliere_logo_alt = /** @type {(inputs: Ateliere_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo Ateliere`)
};

const de_ateliere_logo_alt = /** @type {(inputs: Ateliere_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ateliere Logo`)
};

const it_ateliere_logo_alt = /** @type {(inputs: Ateliere_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo dell'Ateliere`)
};

const ru_ateliere_logo_alt = /** @type {(inputs: Ateliere_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`логотип Ateliere`)
};

const es_ateliere_logo_alt = /** @type {(inputs: Ateliere_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logotipo del taller`)
};

const zh_cn2_ateliere_logo_alt = /** @type {(inputs: Ateliere_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ateliere 标志`)
};

const ja_ateliere_logo_alt = /** @type {(inputs: Ateliere_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アトリエールのロゴ`)
};

const hi_ateliere_logo_alt = /** @type {(inputs: Ateliere_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एटेलियर लोगो`)
};

const pt_pt2_ateliere_logo_alt = /** @type {(inputs: Ateliere_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logotipo do Ateliere`)
};

/**
* | output |
* | --- |
* | "Ateliere logo" |
*
* @param {Ateliere_Logo_AltInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_logo_alt = /** @type {((inputs?: Ateliere_Logo_AltInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Logo_AltInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ateliere_logo_alt(inputs)
	if (locale === "de") return de_ateliere_logo_alt(inputs)
	if (locale === "it") return it_ateliere_logo_alt(inputs)
	if (locale === "ru") return ru_ateliere_logo_alt(inputs)
	if (locale === "es") return es_ateliere_logo_alt(inputs)
	if (locale === "zh-CN") return zh_cn2_ateliere_logo_alt(inputs)
	if (locale === "ja") return ja_ateliere_logo_alt(inputs)
	if (locale === "hi") return hi_ateliere_logo_alt(inputs)
	if (locale === "pt-PT") return pt_pt2_ateliere_logo_alt(inputs)
	return en_ateliere_logo_alt(inputs)
});